module.exports = __webpack_public_path__ + "static/img/2.71d5691.png";


//////////////////
// WEBPACK FOOTER
// ./static/2.png
// module id = yrL/
// module chunks = 1